<template>
  <div class="startpage">
    <h1 class="logo_container">
      <img class="mrs_logo" src="../../assets/img/mrs_logo.svg" width="412" height="54" >
    </h1>
    <!-- <SrcSelectButton class="src_btn" :class="{opened}" @click.native="openUpload($event)"> -->
    <SrcSelectButton class="src_btn">
      <label class="upload_container">
        <input class="upload_image" type="file" style="display: none;" accept="image/*" @change="uploadBackgroundImage($event)">
      </label>
      <div class="btn_container">
        アルバムから選ぶ
        <div class="src_btn_illust">
          <svg class="illust__camera" xmlns="http://www.w3.org/2000/svg" width="60.935" height="48.489" viewBox="0 0 60.935 48.489">
            <g id="illust_camera" transform="translate(-188.463 -356.244)">
              <path class="s_color" id="パス_365" data-name="パス 365" d="M202.889,403.733h-7.354a6.068,6.068,0,0,1-6.068-6.067v-27.08a6.068,6.068,0,0,1,6.068-6.068h9.609l4.771-6.017a2.525,2.525,0,0,1,2.186-1.257H225.76a2.526,2.526,0,0,1,2.186,1.257l4.77,6.017h9.608a6.068,6.068,0,0,1,6.068,6.068v27.08a6.068,6.068,0,0,1-6.068,6.067H202.889Z" transform="translate(0 0)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path class="s_color" id="パス_366" data-name="パス 366" d="M202.263,383.12a1.011,1.011,0,1,1-1.011-1.011A1.011,1.011,0,0,1,202.263,383.12Z" transform="translate(-5.529 -12.762)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <line class="s_color" id="線_40" data-name="線 40" x1="16.965" y1="0.096" transform="translate(189.469 376.043)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <line class="s_color" id="線_41" data-name="線 41" x1="16.886" y1="0.096" transform="translate(231.507 376.281)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <circle class="s_color" id="楕円形_46" data-name="楕円形 46" cx="14.344" cy="14.344" r="14.344" transform="translate(204.586 368.841)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <circle class="s_color" id="楕円形_47" data-name="楕円形 47" cx="10.178" cy="10.178" r="10.178" transform="translate(208.753 373.007)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path class="s_color" id="パス_367" data-name="パス 367" d="M258.175,414.374a7.016,7.016,0,0,1-3.591,3.8" transform="translate(-33.422 -29.323)" fill="none" stroke="#2e2e2b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </svg>
        </div>
      </div>
    </SrcSelectButton>
    <SrcSelectButton class="src_btn" @click.native="setModalThenCloseStartPage">
      <div class="btn_container">
        サンプルから選ぶ
        <div class="src_btn_illust">
          <svg class="illust__room" xmlns="http://www.w3.org/2000/svg" width="96.048" height="77.199" viewBox="0 0 96.048 77.199">
            <g id="illust_room" transform="translate(-2857.873 -343.264)">
              <path class="s_color2" id="パス_934" data-name="パス 934" d="M2880.241,782.676l-13.03.539a2.552,2.552,0,0,0-1.558.512,1.58,1.58,0,0,0-.523.959l-.741,6.182a.725.725,0,0,1-.625.631l-1.6.213a3.854,3.854,0,0,1-.845.016,4.283,4.283,0,0,1-.837-.162l-.518-.154a.721.721,0,0,1-.414-.3.73.73,0,0,1-.114-.482l2.5-20.861q-1.893-7.234-3.957-14.428a2.154,2.154,0,0,1-.026-1.254,2.474,2.474,0,0,1,.629-.985l3.5-3.6a2.251,2.251,0,0,1,.688-.534,1.973,1.973,0,0,1,.936-.113c13.2.745,23.606,1.013,25.066,1.048a1.933,1.933,0,0,1,1.218.441,2.127,2.127,0,0,1,.672,1.061l3.328,11.592a4.636,4.636,0,0,1,.487-.2l14.74-5.05a3.173,3.173,0,0,1,3.231.31,3.5,3.5,0,0,1,1.051,2.36l3.46,33.34a.76.76,0,0,1-.1.479.734.734,0,0,1-.546.339l-.837.111a3.883,3.883,0,0,1-.85.015,4.342,4.342,0,0,1-.863-.171l-1.565-.466a.761.761,0,0,1-.36-.228.717.717,0,0,1-.17-.4l-1.246-12.011-15.279.632-.83,6.922a.841.841,0,0,1-.159.417.758.758,0,0,1-.518.27l-1.593.212a3.843,3.843,0,0,1-.876.013,4.4,4.4,0,0,1-.833-.168l-.435-.129a.724.724,0,0,1-.548-.787l.784-6.543-4.661.193,1.582,15.249a.819.819,0,0,1-.123.542.689.689,0,0,1-.517.3l-.884.118a4.065,4.065,0,0,1-1.682-.146l-1.57-.467a.67.67,0,0,1-.356-.234.932.932,0,0,1-.166-.477l-1.522-14.669Zm61.764-15.628a9.823,9.823,0,0,1-1.141,5.351,5.446,5.446,0,0,1-3.43,3.128,2.481,2.481,0,0,1-1.524-.136c-.26,1.311-.49,2.6-.691,3.832a36.61,36.61,0,0,1,4.452.372c1.748.275,2.877.787,3.03,1.476a47.016,47.016,0,0,1,1.518,5.806,15.323,15.323,0,0,1,.062,6.355,6.327,6.327,0,0,1-3.563,4.009,17.638,17.638,0,0,1-14.056,0,6.324,6.324,0,0,1-3.567-4,15.3,15.3,0,0,1,.058-6.363,46.977,46.977,0,0,1,1.519-5.813c.153-.689,1.281-1.2,3.029-1.476a34.484,34.484,0,0,1,3.7-.344,45.687,45.687,0,0,0-5.556-11.174c-.434-.524-5.131-6.241-6.171-8.846-.441-1.1-.325-1.948.248-2.341a2.421,2.421,0,0,1,1.965-.065,19.031,19.031,0,0,1,7.336,3.764c2.043,1.757,3.882,4.519,3.432,7.339a1.942,1.942,0,0,1-.993,1.6,2.107,2.107,0,0,1-2.163-.606,9.617,9.617,0,0,0-2.02-1.593c-.164-.066-.267-.069-.3-.021s-.01.143.079.276a47.215,47.215,0,0,1,5.655,11.622q.427-.006.855-.005c.353-2.184.747-4.591,1.277-6.733a1.917,1.917,0,0,1-2.516-.947c-.811-1.7.358-3.443,1.75-4.383a8.135,8.135,0,0,1,2.465-1.1c.51-1.659,1.069-3.257,1.678-4.732a2.106,2.106,0,0,0,.05-2.009,2.617,2.617,0,0,0-2.316-.8c-1.684.048-3.807-.1-4.72-1.752a4.411,4.411,0,0,1,.544-4.606,10.911,10.911,0,0,1,7.013-4.6,43.564,43.564,0,0,1,5.645-.4,1.59,1.59,0,0,1-.468-1.8,1.884,1.884,0,0,1,1.587-.9,13.566,13.566,0,0,1,6.066.794c1.053.45,2.326,1.267,2.07,2.594a3.782,3.782,0,0,1-1.785,2.114c-2.247,1.52-4.274,2.663-6.236,4.179-4.422,3.416-5.9,6.575-7.532,11.663a8.516,8.516,0,0,1,2.64.2,1.382,1.382,0,0,1,.725.385,1.272,1.272,0,0,1,.3.7Zm-14.7,28.9a16.239,16.239,0,0,0,12.772,0,4.949,4.949,0,0,0,2.811-3.076,13.971,13.971,0,0,0-.084-5.739,44.655,44.655,0,0,0-1.394-5.371c-.146-.463-.887-.742-1.864-.907a41.8,41.8,0,0,0-5.865-.267,47.1,47.1,0,0,0-5.9.327c-.955.155-1.67.4-1.79.781a44.973,44.973,0,0,0-1.417,5.446,13.942,13.942,0,0,0-.08,5.741,4.945,4.945,0,0,0,2.809,3.068Zm8.114-25.039q.385-1.6.829-3.189a5.84,5.84,0,0,0-1.431.813,3,3,0,0,0-1,1.239,1.394,1.394,0,0,0,.257,1.428l.008.011,0,0h0l0,0h0a3.377,3.377,0,0,0,.593-.145,3.075,3.075,0,0,1,.74-.156Zm2.458-3.634c-.578,1.964-1.074,3.954-1.512,5.954-.052.242-.087.646.1.816.135.12.365.128.7.064a4.113,4.113,0,0,0,2.418-2.37,8.42,8.42,0,0,0,1.013-4.373,7.187,7.187,0,0,0-2.72-.09Zm1.8-8.508a21.208,21.208,0,0,1,5.171-5.741c2.024-1.606,4.313-2.852,6.454-4.3.612-.414,1.106-.837,1.173-1.187s-.444-.673-1.071-.923c-1.357-.542-4.635-1.187-5.877-.673.33.539,1.093,1.224.95,1.8-.08.327-.308.7-1.425.8a51.948,51.948,0,0,0-5.774.4,9.481,9.481,0,0,0-6.126,4.03,3,3,0,0,0-.447,3.067c.573,1.039,2.392,1.034,3.414,1.005a4.568,4.568,0,0,1,2.467.329,2.867,2.867,0,0,1,1.092,1.389Zm-13.49,7.444a1.713,1.713,0,0,1,2.012-.139,7.737,7.737,0,0,1,1.75,1.318c.545.493.916.835,1.126.785s.253-.436.18-1.367a7.768,7.768,0,0,0-2.969-5.118c-1.454-1.25-5.544-3.586-7.446-3.6.082.81,1.146,2.5,2.328,4.161,1.166,1.637,2.447,3.246,3.018,3.958Zm-31.78-1.8.99,3.447.481-4.013-.927.318a2.979,2.979,0,0,0-.544.248Zm2.069,6.6,12.818-.529-.909-8.766a1.6,1.6,0,0,0-.587-1.277,2.019,2.019,0,0,0-1.766-.075l-8.635,2.959-.921,7.688Zm12.968.909-24.947,1.031.837,8.067,24.948-1.031-.838-8.067Zm3.619,20.887,1.082.322a2.7,2.7,0,0,0,1.317.1l-3.4-32.758a1.685,1.685,0,0,0-.547-1.258,1.832,1.832,0,0,0-1.727-.135l-.958.328a2.657,2.657,0,0,1,.681.855,2.963,2.963,0,0,1,.3,1.2h0v.022h0v.023h0v.022q1.622,15.639,3.245,31.278Zm-19.375-10.69-2.079.086-.739,6.168a2.8,2.8,0,0,0,.46.086,2.426,2.426,0,0,0,.536-.009l1.08-.144.742-6.186Zm-31.034-15.314a3.572,3.572,0,0,1,1.8-1.273l1.37-.469q-1.389-4.885-3.828-13.4l-2.407,2.475a.85.85,0,0,0-.246.358.763.763,0,0,0,.026.418q1.687,5.93,3.283,11.889Zm4.542-2.211,11.959-4.1a2.925,2.925,0,0,1,4.322,2.614l.872,8.4,10.469-.433-5.534-19.277a.691.691,0,0,0-.19-.345.611.611,0,0,0-.406-.122c-1.717-.04-12.1-.312-25.1-1.049-.163-.009-.3.01-.357.095a.377.377,0,0,0-.007.326c1.677,5.839,3,10.49,3.968,13.885Zm.4,1.392c.872,3.073,1.371,4.843,1.481,5.238a1.2,1.2,0,0,0,.417.694,1.326,1.326,0,0,0,.847.175l8.775-.363-.75-7.228a1.652,1.652,0,0,0-.542-1.281,1.917,1.917,0,0,0-1.751-.14l-8.478,2.9Zm11.67,7.183-8.954.37a2.391,2.391,0,0,1-1.669-.46,2.637,2.637,0,0,1-.945-1.421q-.077-.277-.7-2.474l-1.556,12.982a4.457,4.457,0,0,1,1.722-.4l12.938-.534-.837-8.066Zm-13.411-6.586-.841.289a2.611,2.611,0,0,0-.987.542,1.55,1.55,0,0,0-.457.981l-2.614,21.8a2.508,2.508,0,0,0,1.033.086l1.041-.139q1.413-11.777,2.825-23.556Zm13.905-4.764-.954.327a2.8,2.8,0,0,1,.994,2.169l3.371,32.492,1.108.33a2.692,2.692,0,0,0,1.289.073q-1.763-16.994-3.527-33.987a1.654,1.654,0,0,0-.589-1.333A1.937,1.937,0,0,0,2879.749,761.821Z" transform="translate(0 -378.24)" fill="#0a0a0a" fill-rule="evenodd"/>
              <g id="グループ_8108" data-name="グループ 8108" transform="translate(2894.192 344.014)">
                <line id="line" data-name="線 53" y2="24.301" transform="translate(16.82 0.37)" fill="none" stroke="#0a0a0a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                <g id="グループ_8107" data-name="グループ 8107" transform="translate(0 0)">
                  <path class="s_color" id="パス_935" data-name="パス 935" d="M3187.53,345.05h-33.641V320.164h33.641Z" transform="translate(-3153.889 -320.164)" fill="none" stroke="#0a0a0a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" fill-rule="evenodd"/>
                  <line class="s_color" id="線_54" data-name="線 54" x1="7.341" y2="6.867" transform="translate(7.235 4.997)" fill="none" stroke="#0a0a0a" stroke-miterlimit="10" stroke-width="1"/>
                  <line class="s_color" id="線_55" data-name="線 55" x1="7.341" y2="6.867" transform="translate(7.276 8.257)" fill="none" stroke="#0a0a0a" stroke-miterlimit="10" stroke-width="1"/>
                  <line class="s_color" id="線_56" data-name="線 56" x1="7.341" y2="6.867" transform="translate(7.276 11.354)" fill="none" stroke="#0a0a0a" stroke-miterlimit="10" stroke-width="1"/>
                  <line class="s_color" id="線_57" data-name="線 57" x1="7.341" y2="6.867" transform="translate(24.215 4.997)" fill="none" stroke="#0a0a0a" stroke-miterlimit="10" stroke-width="1"/>
                  <line class="s_color" id="線_58" data-name="線 58" x1="7.341" y2="6.867" transform="translate(24.257 8.257)" fill="none" stroke="#0a0a0a" stroke-miterlimit="10" stroke-width="1"/>
                  <line class="s_color"  id="線_59" data-name="線 59" x1="7.341" y2="6.867" transform="translate(24.257 11.354)" fill="none" stroke="#0a0a0a" stroke-miterlimit="10" stroke-width="1"/>
                </g>
              </g>
            </g>
          </svg>

        </div>
      </div>
    </SrcSelectButton>
  </div>
</template>

<script>
import SrcSelectButton from '../parts/SrcSelectButton.vue'
// import UploadThenSetBgImage from '../parts/UploadThenSetBgImage.vue'
import { mapMutations, mapActions } from 'vuex'
import { loadImage } from '../../assets/js/loadImageByPromise'
import { compressImage, checkLocalStorageAvailable } from '../../assets/js/util'
import CONST from '../../assets/js/const'

export default {
  components: {
    SrcSelectButton,
    // UploadThenSetBgImage,
  },
  // data () {
  //   return {
  //     opened: false
  //   }
  // },
  methods: {
    ...mapMutations('simulator', ["setSelectedScene"]),
    ...mapActions('simulator', ["resetItemList"]),
    ...mapActions(["resetTimer"]),
    // openUpload (ev) {
    //   const { target: el } = ev
    //   this.opened = !this.opened
    //   el.classList.toggle('active')
    // },
    async uploadBackgroundImage($ev) {
      const [file] = $ev.target.files;
      if ( !this.fileValidation(file) ) return alert('画像のアップロードに失敗しました。\njpeg形式の画像ファイルを選択してください。');

      this.$store.commit('setIsLoading', true);

      const url = URL.createObjectURL(file);

      const img = await loadImage(url);
      const compressed_base64_img = await compressImage(img, 1000000);

      this.setBackgroundImage( await loadImage(compressed_base64_img) );
      if ( checkLocalStorageAvailable() ) localStorage.setItem(CONST.LOCAL_STORAGE_IMG_KEY, compressed_base64_img);
      this.setSelectedScene('');

      this.resetItemList();
      this.resetTimer();

      this.$store.commit('setIsLoading', false);
      this.$emit('toggleStartPage')
    },
    fileValidation(file) {
        if (!file) return false;
        if (file.type !== 'image/jpeg') return false;

        return true;
    },
    setBackgroundImage(img) {
        this.$store.commit('setBackgroundImage', img);
    },
    setModalThenCloseStartPage() {
      this.$store.commit('setModal', 'SelectScene')
      this.$emit('toggleStartPage')
    }
  },
}
</script>

<style lang="scss">
  @import "../../assets/css/define";

  .startpage {
    position: absolute;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    align-items: flex-start;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    .logo_container {
      margin: calc(24 / 667 * 100%) 0;
      width: 100%;
      .mrs_logo {
        display: block;
        margin: 0 auto;
        width: calc(412 / 667 * 100%);
        height: auto;
      }
    }
    .src_btn {
      width: calc(252 / 667 * 100%);
      box-shadow: 0px 3px 6px #ccc;
      .upload_container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
      .btn__wrapper {
        padding: calc(8 / 252 * 100%);
        padding-top: calc(16 / 252 * 100%);
        transition: 0.3s;
      }
      .btn__wrapper:hover {
        background-color: #040404;
        color: #fff;
        #illust_camera .s_color,
        #illust_room .s_color{
          stroke: #fff;
        }
        #illust_room .s_color2{
          fill: #fff;
        }
        #line{
          stroke: #fff !important;
        }
      }
      &.opened {
        outline: none;
        .btn__wrapper{
          background-color: #fff;
          color: #000;
          label{
            cursor: pointer;
          }
          #illust_camera .s_color,
          #illust_room .s_color{
            stroke: #000;
          }
          #illust_room .s_color2{
            fill: #000;
          }
          #line{
            stroke: #000 !important;
          }

        }
      }
      .btn_container {
        box-sizing: content-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        font-size: clamp(12px, 1.6vw, 24px);
        .src_btn_illust {
          width: 100%;
          .illust__camera {
            width: calc(59 / 236 * 100%);
            height: auto;
          }
          .illust__room {
            width: calc(97 / 236 * 100%);
            height: auto;
          }
        }
      }
    }
  }
</style>
